// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleCheckBigIcon,
  PackageIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  TriangleAlertIcon,
  TruckIcon,
  jsxRuntime,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const DeliveryStatusForm = ({ order: e = {}, onUpdate: t }) => {
  const [n, r] = React.useState((e == null ? undefined : e.delivery_status) || "order received"),
    [a, l] = React.useState((e == null ? undefined : e.shipping_company) || ""),
    [c, d] = React.useState((e == null ? undefined : e.tracking_no) || ""),
    [f, h] = React.useState(false),
    [p, g] = React.useState(null),
    [y, v] = React.useState(false),
    j = [
      {
        value: "order received",
        label: "Order Received",
        icon: PackageIcon,
        color: "text-purple-700",
      },
      {
        value: "in process",
        label: "In Process",
        icon: RefreshCwIcon,
        color: "text-yellow-500",
      },
      {
        value: "shipped",
        label: "Shipped",
        icon: TruckIcon,
        color: "text-purple-500",
      },
      {
        value: "delivered",
        label: "Delivered",
        icon: CircleCheckBigIcon,
        color: "text-green-500",
      },
    ],
    N = (_) => {
      (r(_), v(false));
    },
    b = (_) => {
      (l(_.target.value), v(false));
    },
    S = (_) => {
      (d(_.target.value), v(false));
    },
    O = async () => {
      if (!e || !e.purchase_id) {
        g("Invalid order: Missing purchase ID");
        return;
      }
      (h(true), g(null), v(false));
      try {
        const _ = await api.put(`/admin/update-delivery/${e.purchase_id}`, {
          delivery_status: n,
          shipping_company: a,
          tracking_no: c,
        });
        (v(true),
          t &&
            typeof t == "function" &&
            t({
              ...e,
              delivery_status: n,
              shipping_company: a,
              tracking_no: c,
            }));
      } catch (_) {
        (console.error("Error updating delivery status:", _),
          g("Failed to update delivery status. Please try again."));
      } finally {
        h(false);
      }
    };
  return !e || typeof e != "object" ? (
    <div className={"bg-white rounded-xl shadow-sm p-6"}>
      <div className={"flex items-center space-x-3 text-yellow-500"}>
        <TriangleAlertIcon className={"h-5 w-5"} />
        <p className={"text-sm font-medium"}>
          {"No valid order data available. Please select an order first."}
        </p>
      </div>
    </div>
  ) : (
    <div className={"space-y-4"}>
      {p && (
        <div className={"mb-4 bg-red-50 border-l-4 border-red-400 p-4 rounded-md"} role={"alert"}>
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <TriangleAlertIcon className={"h-5 w-5 text-red-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-red-700"}>{p}</p>
            </div>
          </div>
        </div>
      )}
      {y && (
        <div
          className={"mb-4 bg-green-50 border-l-4 border-green-400 p-4 rounded-md"}
          role={"alert"}
        >
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <CircleCheckBigIcon className={"h-5 w-5 text-green-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-green-700"}>{"Delivery status updated successfully!"}</p>
            </div>
          </div>
        </div>
      )}
      <div className={"space-y-4"}>
        <div>
          <label className={"block text-sm font-medium text-gray-700 mb-1"}>
            {"Delivery Status"}
          </label>
          <div className={"grid grid-cols-2 gap-3"}>
            {j.map((_) => (
              <button
                key={_.value}
                type={"button"}
                onClick={() => N(_.value)}
                className={`flex items-center px-4 py-3 rounded-lg border ${n === _.value ? "bg-purple-50 border-purple-300 ring-2 ring-purple-200" : "border-gray-200 hover:bg-gray-50"}`}
              >
                <_.icon className={`h-5 w-5 mr-2 ${_.color}`} />
                <span className={"text-gray-900 font-medium"}>{_.label}</span>
              </button>
            ))}
          </div>
        </div>
        <div>
          <label
            htmlFor={"shipping-company"}
            className={"block text-sm font-medium text-gray-700 mb-1"}
          >
            {"Shipping Company"}
          </label>
          <input
            id={"shipping-company"}
            type={"text"}
            className={
              "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            }
            placeholder={"Enter shipping company name..."}
            value={a}
            onChange={b}
          />
        </div>
        <div>
          <label htmlFor={"tracking-no"} className={"block text-sm font-medium text-gray-700 mb-1"}>
            {"Tracking Number"}
          </label>
          <input
            id={"tracking-no"}
            type={"text"}
            className={
              "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            }
            placeholder={"Enter tracking number..."}
            value={c}
            onChange={S}
          />
        </div>
        <div className={"flex justify-end"}>
          <button
            type={"button"}
            className={
              "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
            }
            onClick={O}
            disabled={f}
          >
            {f ? (
              <jsxRuntime.Fragment>
                <RefreshCwIcon className={"h-5 w-5 mr-2 animate-spin"} />
                {"Updating..."}
              </jsxRuntime.Fragment>
            ) : (
              <jsxRuntime.Fragment>
                <SaveIcon className={"h-5 w-5 mr-2"} />
                {"Update Status"}
              </jsxRuntime.Fragment>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
export { DeliveryStatusForm };
